import { render, staticRenderFns } from "./AddressesListPopup.vue?vue&type=template&id=63691510&scoped=true&"
import script from "./AddressesListPopup.vue?vue&type=script&lang=js&"
export * from "./AddressesListPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddressesListPopup.vue?vue&type=style&index=0&id=63691510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63691510",
  null
  
)

export default component.exports